/**
 *
 * Routes
 *
 */

import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import {
  getNewTokenFailed,
  getNewTokenSuccess,
  reqTokenOnprogress,
  resetFailedRequestProps,
  signOutAction,
} from "../../containers/Authentication/redux/actions";
import { setProfileInfoV2 } from "../../pages/getStarted/redux/actions";
import { resetData, getCustomer } from "../../pages/redux/action";

import {
  setBlockRequest,
  setUnauthorizedNotif,
  stopLoading,
} from "../../globalRedux/actions";

import { theme } from "../../constants";

import RoutesList from "./Routes";

import { hideError, resetALlState } from "../../globalRedux/actions";

import { SwitchingProvider } from "../../contexts/SwitchingContext";
import {
  Dashboard,
  FundSelection,
  FundSelectionList,
  InvestTab,
  SaveTab,
  RetirementTab,
  Switching,
  SwitchingSuccess,
  SwitchingSummary,
  SwitchList,
  DuplicateTransaction,
} from "../../pages";
import {
  getSessionStorage,
  getSessionStorageSync,
  removeSessionStorage,
  setSessionStorage,
} from "../../utils/session";
import { getSessionMasterId } from "../../utils/functions/getSessionValues";

const deepLinkPrefix = "/deeplink/";
function RoutesComponent(props) {
  const { history, resetData, getCustomer, profile } = props;

  const isInDeeplinkAuthProcess =
    /^\/deeplink\/status\/(invest|save|retire)\/[^/]+$/i.test(
      history?.location?.pathname
    ) ||
    /\/plan\/auth\/(supercharge|powersaver)/i.test(history?.location?.pathname);

  const storageList = [
    "reqTokenDate",
    "persist:root",
    "mpUserInfo",
    "isNewUser",
    "currentTab",
    // "mpAccessToken",
    "mpUserStatus",
    "lastNotifyGiveaway",
    // "mpBearerToken",
    // "renew",
    // "masterId",
  ];
  const cleanStorage = () => {
    for (let i = 0; i < storageList.length; i++) {
      localStorage.removeItem(storageList[i]);
    }
    removeSessionStorage("mpAccessToken");
    removeSessionStorage("mpBearerToken");
    removeSessionStorage("renew");
    removeSessionStorage("masterId");
    removeSessionStorage("deeplinkFlow");
    removeSessionStorage("deeplinkLastPath");
    removeSessionStorage("deeplinkResumePending");
    removeSessionStorage("deeplinkProfileResume");
    removeSessionStorage("deeplinkProfileUpdated");
  };

  const checkDeeplink = path => {
    return path.startsWith(deepLinkPrefix) || path.startsWith("/plan");
  };

  async function handleDataCustSuccess(event) {
    if (
      !window.location.href.includes("localhost") &&
      !window.my.hasOwnProperty("call")
    ) {
      return alert("Cannot login via actual url, Please use localhost");
    }

    const { productType, customerInfo, token } = event.detail;

    await setSessionStorage("masterId", customerInfo.masterId);
    props.setProfileInfoV2(customerInfo);
    await setSessionStorage("mpBearerToken", token);
    props.getNewTokenSuccess(token);
    props.reqTokenOnprogress(false);
    localStorage.setItem("reqTokenDate", Date.now());
    window["TOKEN_ERROR"] = false;
    // If the session was restored after expiring mid-deeplink, resume on the
    // remembered deeplink page instead of the default dashboard routing. The
    // `deeplinkResumePending` flag is set by the token-refresh handler in
    // api.js when a deeplink/plan session expires.
    if (getSessionStorageSync("deeplinkResumePending") === "1") {
      const resumePath = getSessionStorageSync("deeplinkLastPath");
      removeSessionStorage("deeplinkResumePending");
      removeSessionStorage("deeplinkLastPath");
      removeSessionStorage("deeplinkFlow");
      if (resumePath) {
        console.log("[SESSION-FLOW] resume deeplink ->", resumePath);
        return history.push(resumePath);
      }
    }
    window.eventManager.fire("CUSTOMER_PRODUCT_TYPE", {
      productType,
      profile: customerInfo,
    });
  }

  function handleDataCustFail() {
    props.reqTokenOnprogress(false);
    props.getNewTokenFailed();
    props.setUnauthorizedNotif();

    resetData();
    props.resetALlState();
    cleanStorage();

    if (
      history.location.pathname.includes("/deeplink") ||
      history.location.pathname.includes("/plan")
    ) {
      return history.push(history.location.pathname);
    }

    history.push("/");
  }

  useEffect(() => {
    const setStorage = async () => {
      // TODO: check if this is mismatching or not
      const masterId = await getSessionMasterId();
      // console.log("masterId:", masterId);
      // console.log("profile?.masterId:", profile?.masterId);
      if (masterId && !profile?.masterId) {
        getCustomer();
      } else if (
        (masterId && profile?.masterId && masterId !== profile.masterId) ||
        (!masterId && profile?.masterId)
      ) {
        handleDataCustFail();
        console.log("clearing data...");
      }
    };
    if (isInDeeplinkAuthProcess) return;

    setStorage();
  }, []);

  // Scroll to top on route change & handle invalid token event listener
  useEffect(() => {
    window.scrollTo(0, 0);
    const step = props.globalProps.globalData.step;
    const currentPath = window.location.pathname;

    if (step !== null && !checkDeeplink(currentPath)) {
      history.push(step);
    }

    const invalidTokenListener = window.eventEmitter.addListener(
      "invalid_token",
      () => {
        //if (step !== "/") {
        props.reqTokenOnprogress(false);
        props.getNewTokenFailed();
        props.setUnauthorizedNotif();
        cleanStorage();
        history.push("/");

        //props.signOutAction();
        //   setAuth(false);
        // }
      }
    );

    document.addEventListener(
      "CUSTOMER_SET_STATUS_ROOT",
      handleDataCustSuccess
    );
    document.addEventListener("CUSTOMER_SET_FAIL_ROOT", handleDataCustFail);

    return () => {
      invalidTokenListener.remove();
      document.removeEventListener(
        "CUSTOMER_SET_STATUS_ROOT",
        handleDataCustSuccess
      );
      document.removeEventListener(
        "CUSTOMER_SET_FAIL_ROOT",
        handleDataCustFail
      );
    };
  }, []);

  useEffect(() => {
    if (isInDeeplinkAuthProcess) return;

    const unlisten = history.listen(async () => {
      const bearerToken = await getSessionStorage("mpBearerToken");
      const masterId = await getSessionMasterId();

      if (masterId && !bearerToken) {
        props.getNewTokenFailed();
      }
    });

    return unlisten;
  }, []);

  useEffect(() => {
    const checkRedirection = async () => {
      const storedMasterId = await getSessionMasterId();
      if (
        ((!storedMasterId || !profile) && !isInDeeplinkAuthProcess) ||
        (storedMasterId &&
          profile &&
          !isInDeeplinkAuthProcess &&
          storedMasterId !== profile.masterId)
      ) {
        handleDataCustFail();

        console.log("clearing data...");
      }
      if (
        props.location.pathname === "/make-deposit/DASHBOARD" ||
        props.location.pathname === "/step-three" ||
        props.location.pathname === "/make-deposit/GOALDETAILS" ||
        props.location.pathname === "/make-deposit/GOAL_CREATION" ||
        props.location.pathname === "/dashboard"
      ) {
        props.setBlockRequest(false);
      }
      if (props.location.pathname === "/dashboard") {
        const local = JSON.parse(localStorage.getItem("currentTab"));
        if (local) {
          history.push(`/dashboard/${local.name}`);
        }
      }

      // switching dropdown have problem
      // when user have risk profile expired
      // system will prompt error message
      // and that prompt somehow causing react-spring-bottom-sheet
      // to not removing `overflow: hidden`
      // eg: `overflow: hidden` is still there when `/switching` page is unmounted (usually the `overflow: hidden` is gone when bottom-sheet is unmounted)
      // so in here we manually reset the body style so that user can scroll down & up
      if (
        props.location.pathname.includes("/fund-selection") ||
        props.location.pathname.includes("/invest-introduction") ||
        props.location.pathname.includes("/risk-assessment") ||
        props.location.pathname === "/switching/create"
      ) {
        document.body.style = "";
      }
    };
    checkRedirection();
  }, [props.location.pathname, isInDeeplinkAuthProcess]);

  return (
    <ThemeProvider theme={theme}>
      {RoutesList.map(({ exact, path, component }, i) => {
        let redirectPath = "/";
        if (props.location.pathname === "/") {
          if (props.location.search) {
            const reg = new RegExp("[?&]redirect=([^&#]*)", "i");
            const string = reg.exec(props.location.search);
            if (string) {
              if (string.length > 1) {
                redirectPath = string[1];
              }
            }
          }
        }
        return (
          <React.Fragment key={`Route-${i + 1}`}>
            <Route
              exact={exact}
              path={path}
              component={component}
              key={`Route-${i + 1}`}
            />
          </React.Fragment>
        );
      })}
      <Route
        path="/fund-selection"
        render={({ match: { url } }) => (
          <FundSelection>
            {props => (
              <>
                <Route
                  path={`${url}/conservative`}
                  render={() => <FundSelectionList {...props} />}
                />
                <Route
                  path={`${url}/moderate`}
                  render={() => <FundSelectionList {...props} />}
                />
                <Route
                  path={`${url}/aggressive`}
                  render={() => <FundSelectionList {...props} />}
                />
              </>
            )}
          </FundSelection>
        )}
      />
      <Route
        path="/dashboard"
        render={({ match: { url } }) => (
          <Dashboard>
            {props => (
              <>
                <Route
                  path={`${url}/Save`}
                  render={() => <SaveTab {...props} />}
                />
                <Route
                  path={`${url}/Invest`}
                  render={() => <InvestTab {...props} />}
                />
                <Route
                  path={`${url}/Retirement`}
                  render={() => <RetirementTab {...props} />}
                />
              </>
            )}
          </Dashboard>
        )}
      />
      <Route
        path="/switching"
        render={({ match: { url } }) => (
          <SwitchingProvider>
            <Route
              path={`${url}/create`}
              render={() => (
                <Switching>
                  <Route
                    path={`${url}/create/switch-from`}
                    render={({ match: { url: switchFromUrl } }) => (
                      <SwitchList>
                        <Route
                          path={`${switchFromUrl}/goals`}
                          component={SwitchList.Content}
                        />
                        <Route
                          path={`${switchFromUrl}/funds`}
                          component={SwitchList.Content}
                        />
                      </SwitchList>
                    )}
                  />
                  <Route
                    path={`${url}/create/switch-to`}
                    render={({ match: { url: switchToUrl } }) => (
                      <SwitchList>
                        <Route
                          path={`${switchToUrl}/goals`}
                          component={SwitchList.Content}
                        />
                        <Route
                          path={`${switchToUrl}/funds`}
                          component={SwitchList.Content}
                        />
                      </SwitchList>
                    )}
                  />
                </Switching>
              )}
            />
            <Route path={`${url}/summary`} exact component={SwitchingSummary} />
            <Route path={`${url}/success`} exact component={SwitchingSuccess} />
            <Route
              path={`${url}/duplicate-transaction`}
              exact
              component={DuplicateTransaction}
            />
          </SwitchingProvider>
        )}
      />
    </ThemeProvider>
  );
}

RoutesComponent.propTypes = {
  auth: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  location: PropTypes.object,
  globalProps: PropTypes.object.isRequired,
  signOutAction: PropTypes.func.isRequired,
  setUnauthorizedNotif: PropTypes.func.isRequired,
  setProfileInfoV2: PropTypes.func.isRequired,
  getNewTokenSuccess: PropTypes.func.isRequired,
  reqTokenOnprogress: PropTypes.func.isRequired,
  getNewTokenFailed: PropTypes.func.isRequired,
  setBlockRequest: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
    clients: state.clientReducer,
    selectedObject: state.breadCrumbsReducer,
    globalProps: state.globalReducer,
    goal: state.goal,
    profile: state.goal.profile,
  };
};

const mapDispatchToProps = {
  signOutAction,
  stopLoading,
  resetFailedRequestProps,
  hideError,
  setBlockRequest,
  setUnauthorizedNotif,
  setProfileInfoV2,
  getNewTokenSuccess,
  reqTokenOnprogress,
  getNewTokenFailed,
  resetALlState,
  resetData,
  getCustomer,
};

const Routes = compose(
  withRouter,

  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(RoutesComponent);

export default Routes;
